<template>
  <!--手机端-->
  <div class="caseMobile" v-if="isMobile">
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <video :src="caseObj[tabArray[tabIndex].code].banner" class="posAbsoluteAll objFitCover"
             autoplay loop :muted="isMuted" v-if="tabArray[tabIndex].code==='nc'" :webkit-playsinline='true'
             :playsinline='true'></video>
      <div v-if="tabArray[tabIndex].code==='nc'">
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba2.png" class="img-laba anim-bigger-small"
             v-if="isMuted"
             @click.stop="isMuted=false">
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba1.png" class="img-laba anim-bigger-small"
             v-else @click.stop="isMuted=true">
      </div>
      <img :src="caseObj[tabArray[tabIndex].code].banner" class="posAbsoluteAll" draggable="false" v-else>
      <div class="banner-text colorfff">
        <div class="font-size50 font-bold">经营业务</div>
        <div class="line1 margin-top15 margin-bottom15"></div>
        <div class="font-size30">BUSINESS OPERATIONS</div>
      </div>
    </div>
    <div class="row-me row-center tab-div">
      <div class="tab" :class="{'tab-active':tabIndex===index}" v-for="(item, index) in tabArray" :key="index"
           @click="clickTab(index)">
        <span v-if="language==='0'">{{ item.name }}</span>
        <span v-if="language==='1'">{{ item.enName }}</span>
      </div>
    </div>
    <div class="content-div">
      <div class="column-me row-center">
        <div class="font-size40 font-bold keep-all" v-if="language==='0'">{{ tabArray[tabIndex].name }}</div>
        <div class="font-size40 font-bold keep-all" v-if="language==='1'">{{ tabArray[tabIndex].enName }}</div>
        <div class="font-size20 color666 margin-top20" v-if="language==='0'">{{ tabArray[tabIndex].enName }}</div>
      </div>
      <div class="font-size26 lineH40 margin-top50">
        <div v-html="caseObj[tabArray[tabIndex].code].cn" v-if="language==='0'"></div>
        <div v-html="caseObj[tabArray[tabIndex].code].en" v-if="language==='1'"></div>
      </div>

      <div v-if="tabArray[tabIndex].code!=='xmt'">
        <div class="column-me row-center">
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='0'">主营品种</div>
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='1'">Major businesses</div>
          <div class="line2"></div>
        </div>
        <div class="font-size26 lineH40">
          <div v-html="caseObj[tabArray[tabIndex].code].product" v-if="language==='0'"></div>
          <div v-html="caseObj[tabArray[tabIndex].code].productEn" v-if="language==='1'"></div>
        </div>
        <!--农产-->
        <div class="row-me column-center flex-wrap margin-top10" v-if="tabArray[tabIndex].code==='nc'">
          <div class="item-product column-me row-center margin-top50" v-for="(item, index) in productArray"
               :key="index">
            <img :src="item.img" class="img-product" draggable="false">
            <div class="font-size20 margin-top20" v-if="language==='0'">{{ item.name }}</div>
            <div class="font-size20 margin-top20" v-if="language==='1'">{{ item.enName }}</div>
          </div>
        </div>
      </div>

      <!--新媒体-->
      <div v-if="tabArray[tabIndex].code==='xmt'">
        <div class="column-me row-center">
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='0'">我们可以为客户提供</div>
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='1'">We can provide for customers
          </div>
          <div class="line2"></div>
        </div>
        <div class="width100Per row-me flex-wrap">
          <div class="column-me row-center margin-bottom40 margin-right80 mR0-4" v-for="(item, index) in applyArray"
               :key="index">
            <img :src="item.img" class="img-apply" draggable="false">
            <div class="font-size18 margin-top20 width100 text-align" v-if="language==='0'">{{ item.name }}</div>
            <div class="font-size18 margin-top20 width100 text-align" v-if="language==='1'">{{ item.enName }}</div>
          </div>
        </div>
        <div class="column-me row-center">
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='0'">服务企业</div>
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='1'">Service companies</div>
          <div class="line2"></div>
        </div>
        <div class="row-me column-center flex-wrap">
          <div class="item-company column-me row-center margin-bottom50" v-for="(item, index) in companyArray"
               :key="index">
            <img :src="item.img" class="img-company" draggable="false">
          </div>
        </div>
      </div>

      <div>
        <div class="column-me row-center">
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='0'">运营单位</div>
          <div class="font-size40 font-bold margin-top100 keep-all" v-if="language==='1'">Operating units</div>
          <div class="line2"></div>
        </div>
        <div class="width100Per column-me row-center">
          <div class="company-div" v-for="(item, index) in caseObj[tabArray[tabIndex].code].company" :key="index"
               @click="clickCompany(item)">
            <span v-if="language==='0'">{{ item.cn }}</span>
            <span v-if="language==='1'">{{ item.en }}</span>
          </div>
        </div>
      </div>

    </div>

    <!--运营单位弹窗-->
    <el-dialog v-model="visible" width="90%" top="20vh" :destroy-on-close="true">
      <template #title>
        <div class="company-info">
          <div class="top-div row-me center-all posRelative">
            <span class="font-size26 font-bold colorfff line1 mLR50" v-if="language==='0'">{{ selectCompany.cn }}</span>
            <span class="font-size26 font-bold colorfff line1 mLR50" v-if="language==='1'">{{ selectCompany.en }}</span>
          </div>
        </div>
      </template>
      <div class="font-size24 color000 padding20">
        <div v-if="language==='0'">电话：66853296</div>
        <div v-if="language==='1'">Telephone：66853296</div>
        <div class="margin-top30" v-if="language==='0'">邮箱：lanchunlei@qdclfz.com</div>
        <div class="margin-top30" v-if="language==='1'">E-mail：lanchunlei@qdclfz.com</div>
        <div class="line3"></div>
        <div class="column-me row-center">
          <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_ewm.png" class="img-code"
               draggable="false">
          <div class="margin-top20" v-if="language==='0'">扫描二维码关注我们</div>
          <div class="margin-top20" v-if="language==='1'">Scan QR code to subscribe us</div>
        </div>
      </div>
    </el-dialog>

  </div>

  <!--电脑端-->
  <div class="case" v-else>
    <div class="img-bg posRelative" @contextmenu.prevent="disableContextMenu">
      <video :src="caseObj[tabArray[tabIndex].code].banner" class="posAbsoluteAll objFitCover"
             autoplay loop :muted="isMuted" v-if="tabArray[tabIndex].code==='nc'"></video>
      <div v-if="tabArray[tabIndex].code==='nc'">
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba2.png" class="img-laba anim-bigger-small"
             v-if="isMuted"
             @click.stop="isMuted=false">
        <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/laba1.png" class="img-laba anim-bigger-small"
             v-else @click.stop="isMuted=true">
      </div>
      <img :src="caseObj[tabArray[tabIndex].code].banner" class="posAbsoluteAll" draggable="false" v-else>
      <div class="banner-text colorfff">
        <div class="font-size60 font-bold">经营业务</div>
        <div class="line1 margin-top30 margin-bottom30"></div>
        <div class="font-size30">BUSINESS OPERATIONS</div>
      </div>
    </div>
    <div class="row-me row-center tab-div">
      <div class="tab" :class="{'tab-active':tabIndex===index}" v-for="(item, index) in tabArray" :key="index"
           @click="clickTab(index)">
        <span v-if="language==='0'">{{ item.name }}</span>
        <span v-if="language==='1'">{{ item.enName }}</span>
      </div>
    </div>
    <div class="content-div">
      <div class="column-me row-center">
        <div class="font-size40 font-bold keep-all" v-if="language==='0'">{{ tabArray[tabIndex].name }}</div>
        <div class="font-size40 font-bold keep-all" v-if="language==='1'">{{ tabArray[tabIndex].enName }}</div>
        <div class="font-size20 color666 margin-top20" v-if="language==='0'">{{ tabArray[tabIndex].enName }}</div>
      </div>
      <div class="font-size18 lineH40 margin-top60">
        <div v-html="caseObj[tabArray[tabIndex].code].cn" v-if="language==='0'"></div>
        <div v-html="caseObj[tabArray[tabIndex].code].en" v-if="language==='1'"></div>
      </div>

      <div class="column-me row-center" v-if="tabArray[tabIndex].code!=='xmt'">
        <div class="font-size40 font-bold margin-top100" v-if="language==='0'">主营品种</div>
        <div class="font-size40 font-bold margin-top100" v-if="language==='1'">Major businesses</div>
        <div class="line2"></div>
        <div class="font-size18 lineH40">
          <div v-html="caseObj[tabArray[tabIndex].code].product" v-if="language==='0'"></div>
          <div v-html="caseObj[tabArray[tabIndex].code].productEn" v-if="language==='1'"></div>
        </div>
        <!--农产-->
        <div class="row-me column-center flex-wrap margin-top10" v-if="tabArray[tabIndex].code==='nc'">
          <div class="item-product column-me row-center margin-top50" v-for="(item, index) in productArray"
               :key="index">
            <img :src="item.img" class="img-product" draggable="false">
            <div class="font-size20 margin-top20" v-if="language==='0'">{{ item.name }}</div>
            <div class="font-size20 margin-top20" v-if="language==='1'">{{ item.enName }}</div>
          </div>
        </div>
      </div>

      <!--新媒体-->
      <div class="column-me row-center" v-if="tabArray[tabIndex].code==='xmt'">
        <div class="font-size40 font-bold margin-top100" v-if="language==='0'">我们可以为客户提供</div>
        <div class="font-size40 font-bold margin-top100" v-if="language==='1'">We can provide for customers</div>
        <div class="line2"></div>
        <div class="width100Per row-me center-all flex-sb">
          <div class="column-me row-center" v-for="(item, index) in applyArray" :key="index">
            <img :src="item.img" class="img-apply" draggable="false">
            <div class="font-size18 margin-top20 text-align" v-if="language==='0'">{{ item.name }}</div>
            <div class="font-size18 margin-top20 text-align" v-if="language==='1'">{{ item.enName }}</div>
          </div>
        </div>
        <div class="font-size40 font-bold margin-top100" v-if="language==='0'">服务企业</div>
        <div class="font-size40 font-bold margin-top100" v-if="language==='1'">Service companies</div>
        <div class="line2"></div>
        <div class="row-me column-center flex-wrap">
          <div class="item-company column-me row-center margin-bottom50" v-for="(item, index) in companyArray"
               :key="index">
            <img :src="item.img" class="img-company" draggable="false">
          </div>
        </div>
      </div>

      <div class="column-me row-center">
        <div class="font-size40 font-bold margin-top100" v-if="language==='0'">运营单位</div>
        <div class="font-size40 font-bold margin-top100" v-if="language==='1'">Operating units</div>
        <div class="line2"></div>
        <div class="width100Per row-me flex-wrap">
          <div class="company-div" v-for="(item, index) in caseObj[tabArray[tabIndex].code].company" :key="index"
               @click="clickCompany(item)">
            <div class="mLR50" v-if="language==='0'">{{ item.cn }}</div>
            <div class="mLR50" v-if="language==='1'">{{ item.en }}</div>
          </div>
        </div>
      </div>

    </div>

    <!--运营单位弹窗-->
    <el-dialog v-model="visible" width="1040px" top="20vh" :destroy-on-close="true">
      <template #title>
        <div class="company-info">
          <div class="top-div row-me center-all posRelative">
            <span class="font-size26 font-bold colorfff line1 margin-left40 margin-right80"
                  v-if="language==='0'">{{ selectCompany.cn }}</span>
            <span class="font-size26 font-bold colorfff line1 margin-left40 margin-right80"
                  v-if="language==='1'">{{ selectCompany.en }}</span>
          </div>
        </div>
      </template>
      <div class="font-size18 color000 padding20">
        <div v-if="language==='0'">电话：66853296</div>
        <div v-if="language==='1'">Telephone：66853296</div>
        <div class="margin-top30" v-if="language==='0'">邮箱：lanchunlei@qdclfz.com</div>
        <div class="margin-top30" v-if="language==='1'">E-mail：lanchunlei@qdclfz.com</div>
        <div class="line3"></div>
        <div class="column-me row-center">
          <img src="https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_ewm.png" class="img-code"
               draggable="false">
          <div class="margin-top20" v-if="language==='0'">扫描二维码关注我们</div>
          <div class="margin-top20" v-if="language==='1'">Scan QR code to subscribe us</div>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {caseObj} from "@/views/data/case";

export default {
  components: {},
  data() {
    return {
      caseObj: caseObj,
      tabArray: [],
      tabIndex: 0,
      language: '', //0中文，1英文
      isMobile: '', //0电脑，1手机
      visible: false,
      selectCompany: {},
      productArray: [],//农产品种集合
      applyArray: [],//新媒体提供集合
      companyArray: [],//新媒体服务企业集合
      isMuted: true, //视频是否静音
    }
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (val.query.index) {
          this.tabIndex = Number(val.query.index)
        }
      },
      deep: true
    },
  },
  computed: {},
  created() {
    this.isMobile = sessionStorage.getItem("mobile") === '1'
    this.language = sessionStorage.getItem("language")
    if (this.$route.query.index) {
      this.tabIndex = Number(this.$route.query.index)
    }
    this.tabArray = [
      {name: "冶金", enName: 'Metallurgy', code: 'yj',},
      {name: "能化", enName: 'Energy and Chemical Industry', code: 'nh',},
      {name: "有色", enName: 'Nonferrous Metallurgical', code: 'ys',},
      {name: "纺织", enName: 'Textile', code: 'fz',},
      {name: "浆纸", enName: 'Pulp', code: 'jz',},
      {name: "农产", enName: 'Agriculture', code: 'nc',},
      {name: "冻品", enName: 'Frozen Goods', code: 'dp',},
      {name: "新媒体", enName: 'New Media', code: 'xmt',},
    ]
    this.productArray = [
      {name: '玉米', enName: 'corn', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_ym.png'},
      {name: '马铃薯', enName: 'potatoes', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_mls.png'},
      {name: '大麦', enName: 'barley', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_dm.png'},
      {name: '亚麻籽', enName: 'flaxseeds', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_ymz.png'},
      {
        name: '葵花籽',
        enName: 'sunflower seeds',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_khz.png'
      },
      {name: '小麦', enName: 'wheat', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_xm.png'},
      {name: '大豆', enName: 'soybeans', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_dd.png'},
      {
        name: '葵花籽仁',
        enName: 'sunflower kernels',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_khzr.png'
      },
      {
        name: '麦麸颗粒',
        enName: 'bran granules',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_mfkl.png'
      },
      {name: '豌豆', enName: 'peas', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_wd.png'},
      {name: '荞麦', enName: 'buckwheat', img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/img_qm.png'},
    ]
    this.applyArray = [
      {
        name: '品牌战略咨询与设计',
        enName: 'brand strategy consulting and design',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_ppzl.png'
      },
      {
        name: '产品策略包装设计',
        enName: 'product strategy packaging design',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_cpcl.png'
      },
      {
        name: '品牌IP设计',
        enName: 'brand IP design',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_ppip.png'
      },
      {
        name: '品牌年度推广设计',
        enName: 'annual brand promotion design',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_ppnd.png'
      },
      {
        name: '宣传片',
        enName: 'promotional videos',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_xcp.png'
      },
      {
        name: '地产动画',
        enName: 'real estate animation',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_dcdh.png'
      },
      {
        name: '产品动画',
        enName: 'product animation',
        img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/icon_cpdh.png'
      },
    ]
    this.companyArray = [
      {img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/logo1.png'},
      {img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/logo2.png'},
      {img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/logo3.png'},
      {img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/logo4.png'},
      {img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/logo5.png'},
      {img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/logo6.png'},
      {img: 'https://chenglong-web.oss-cn-qingdao.aliyuncs.com/img/logo7.png'},
    ]
  },
  mounted() {

  },
  methods: {
    disableContextMenu(event) {
      event.preventDefault();
    },
    clickTab(index) {
      this.$router.push({
        path: '/case',
        query: {
          index: index
        },
      })
    },
    clickCompany(item) {
      this.selectCompany = item
      this.visible = true
    },
  },
}
</script>

<style lang="scss" scoped>
.caseMobile {
  .img-laba {
    width: 60px;
    height: 60px;
    object-fit: cover;
    position: absolute;
    bottom: 5%;
    right: 3%;
    cursor: pointer;
  }

  .img-bg {
    width: 100%;
    height: 560px;

    .banner-text {
      position: absolute;
      left: 30px;
      top: 336px;

      .line1 {
        width: 54px;
        height: 8px;
        background: #FFFFFF;
      }
    }
  }

  .tab-div {
    width: 100%;
    background: #F4F4F4;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);
    overflow: auto;

    .tab {
      min-width: 113px;
      padding: 0 20px;
      font-size: 26px;
      color: #000000;
      text-align: center;
      line-height: 80px;
      user-select: none;
      cursor: pointer;
      flex: 0 0 auto;

      &:hover {
        background: #D60110;
        color: #FFFFFF;
      }

      &-active {
        background: #D60110;
        color: #FFFFFF;
      }
    }
  }

  .content-div {
    padding: 50px 30px;

    .company-div {
      font-size: 24px;
      color: #D60110;
      font-weight: bold;
      user-select: none;
      cursor: pointer;
      text-align: center;
      margin: 20px 0;

      &:hover {
        background: #F4F4F4;
      }
    }
  }

  .line2 {
    width: 100%;
    height: 1px;
    background: #BFBFBF;
    margin: 30px 0;
  }

  .line3 {
    width: 100%;
    height: 1px;
    background: #BFBFBF;
    margin: 50px 0;
  }

  .company-info {
    .top-div {
      height: 100px;
      background: #D60110;
    }
  }

  &:deep(.el-dialog__header) {
    height: auto;
  }

  &:deep(.el-dialog__headerbtn) {
    top: 30px;
  }

  &:deep(.el-dialog__headerbtn .el-dialog__close) {
    font-size: 35px;
    color: #FFFFFF;
  }

  .item-product {
    margin-left: 21px;
    margin-right: 21px;

    &:nth-child(1) {
      margin-left: 0;
    }

    &:nth-child(6) {
      margin-right: 0;
    }

    .img-product {
      width: 80px;
      height: 80px;
    }
  }

  .img-apply {
    width: 60px;
    height: 60px;
  }

  .item-company {
    margin-left: 11px;
    margin-right: 11px;

    &:nth-child(1) {
      margin-left: 0;
    }

    &:nth-child(4) {
      margin-right: 0;
    }

    &:nth-child(n + 4) {
      margin-bottom: 0;
    }

    .img-company {
      width: 155.31px;
      height: 54.42px;
    }
  }

  .img-code {
    width: 240px;
    height: 240px;
  }
}

.case {
  .img-bg {
    width: 100%;
    height: 750px;

    .banner-text {
      position: absolute;
      left: 200px;
      top: 370px;

      .line1 {
        width: 54px;
        height: 8px;
        background: #FFFFFF;
      }
    }
  }

  .tab-div {
    height: 80px;
    padding-left: 200px;
    background: #F4F4F4;
    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.1);

    .tab {
      min-width: 120px;
      padding: 0 20px;
      font-size: 20px;
      color: #000000;
      text-align: center;
      line-height: 80px;
      user-select: none;
      cursor: pointer;

      &:hover {
        background: #D60110;
        color: #FFFFFF;
      }

      &-active {
        background: #D60110;
        color: #FFFFFF;
      }
    }
  }

  .content-div {
    padding: 100px 200px;

    .company-div {
      width: 50%;
      padding: 20px 0;
      font-size: 24px;
      color: #D60110;
      font-weight: bold;
      user-select: none;
      cursor: pointer;

      &:hover {
        background: #F4F4F4;
      }
    }
  }

  .line2 {
    width: 100%;
    height: 1px;
    background: #BFBFBF;
    margin: 30px 0;
  }

  .line3 {
    width: 100%;
    height: 1px;
    background: #BFBFBF;
    margin: 50px 0;
  }

  .company-info {
    .top-div {
      height: 100px;
      background: #D60110;
    }
  }

  &:deep(.el-dialog__header) {
    height: auto;
  }

  &:deep(.el-dialog__headerbtn) {
    top: 30px;
  }

  &:deep(.el-dialog__headerbtn .el-dialog__close) {
    font-size: 35px;
    color: #FFFFFF;
  }

  .item-product {
    margin-left: 56px;
    margin-right: 56px;

    &:nth-child(1) {
      margin-left: 0;
    }

    &:nth-child(6) {
      margin-right: 0;
    }

    .img-product {
      width: 160px;
      height: 160px;
      object-fit: scale-down;
    }
  }

  .img-apply {
    width: 80px;
    height: 80px;
    object-fit: scale-down;
  }

  .item-company {
    margin-left: 25px;
    margin-right: 25px;

    &:nth-child(1) {
      margin-left: 0;
    }

    &:nth-child(4) {
      margin-right: 0;
    }

    &:nth-child(n + 4) {
      margin-bottom: 0;
    }

    .img-company {
      width: 342.5px;
      height: 120px;
      object-fit: scale-down;
    }
  }

  .img-code {
    width: 240px;
    height: 240px;
  }
}
</style>
